import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-navbar',
  standalone: false,
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css',
})
export class NavbarComponent implements OnInit {
  isComplianceAdmin = false;
  isWalletsViewer = false;
  isMobileMenuOpen = false;
  showSecurityModal = false;

  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  openSecurityModal() {
    this.showSecurityModal = true;
    this.isMobileMenuOpen = false;
  }

  closeSecurityModal() {
    this.showSecurityModal = false;
  }

  ngOnInit() {
    this.checkPrivileges();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isMobileMenuOpen = false;
      }
    });
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  logout() {
    this.authService.logout().then(() => {
      localStorage.clear();
      sessionStorage.clear();

      this.router.navigate(['/']);
      window.location.href = '/';
    });
  }

  checkPrivileges() {
    this.isComplianceAdmin = this.authService.isComplianceAdmin();
    this.isWalletsViewer =
      !environment.production || this.authService.isWalletsViewer();
  }
}
